/** @format */
import { Button } from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';
import React, { FunctionComponent, useContext, useState } from 'react';
import styled from 'styled-components';

import { MarketContext } from '@toucan/client/global/market';

import { FullBasketErrorModalContentProps } from './types';

const StyledContainer = styled.div`
    text-align: center;

    .heading {
        margin-bottom: var(--layout-spacing-16);
    }

    button {
        margin-top: var(--layout-spacing-24);
        margin-bottom: 0;
    }
`;

export const FullBasketErrorModalContent: FunctionComponent<
    FullBasketErrorModalContentProps
> = ({ maxItems = 0 }) => {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    return (
        <StyledContainer>
            <Heading size={HeadingSize.H2} className="heading">
                {t("Your basket's full up")}
            </Heading>
            <p>
                {t(
                    'You can only add {{basketMaxItems}} items. To add something else, please remove an item first.',
                    {
                        basketMaxItems: maxItems,
                    }
                )}
            </p>
            <NextLink
                prefetch={false}
                href="/basket"
                as={`/${activeMarket.slug}/s/${t('basket', {
                    ns: 'urls',
                })}`}
                passHref={true}
            >
                <Button
                    isLoading={isButtonLoading}
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsButtonLoading(true);
                    }}
                >
                    {t('Edit basket')}
                </Button>
            </NextLink>
        </StyledContainer>
    );
};
